import React, { PropTypes, Component } from 'react';
import Moment from 'moment';
import Blazy from 'blazy';
import Classes from './gridhelper/generatePostClassesWithTerms';
const $ = jQuery;


class latestGridLayoutOne extends Component {
  constructor(props) {
    super(props);
    this.hideLoadingGig = this.hideLoadingGig.bind(this);
    this.state = {
      isotope: false,
    };
  }
  componentWillMount() {
    const post = this.props.post;
    this.termAsClasses = Classes.generatePostClassesWithTerms(post.terms);
    this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
  }
  componentDidMount() {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });
  }
  componentWillReceiveProps(nextProps) {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });    
  }
  hideLoadingGig(ele) {
    const id = this.props.post.ID;
     $('.dummyClass' + id).removeClass('lazyLoading');
  }
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    const post = this.props.post;
    let termAsClasses = this.termAsClasses;
    termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
    const view = this.props.view;
    let imgStyle = null;
    if (this.state.isotope === false) {
      imgStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
        height: '100%',
      };
    } else {
      imgStyle = {
        backgroundImage: 'url(' + post.thumb_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
        height: '100%',
      };
    }
    return (<div>
      { view === 'grid' ?
      <div className="rq-image-grid">
        <div className="rq-grid-normal full-width-bg-image no-border-radius">
           <div className="post-image-container" >
              <div className={this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'image-hover-coantainer post-image-container-list'} style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                <a href={post.post_link}>
                  <div className="img-overlay white-color"><h4 className="rq-post-title">{post.post_title}</h4></div>
                </a>
              </div>
            </div>
        </div>
        </div>
        :
        <div className="flex-row">
          <div className="flex-md-12 flex-sm-12 flex-xs-12">
            <div className="rq-image-grid">
              <div className="rq-grid-normal with-left-image">
                <div className="flex-row">
                  <div className={this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list' } style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                    <div className="img-overlay"><a href={post.post_link}><i className="ion-android-add"></i></a></div>
                  </div>
                  <div className="flex-md-7 flex-sm-12 flex-xs-12">
                    <div className="post-content">
                      <h2><a href={post.post_link}>{post.post_title}</a></h2>
                      <span className="post-date">{ Moment(post.post_date).format('ll') }</span>
                      <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
                      <a href={post.post_link} className="btn btn-blog">{API.LANG.MORE}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      }
    </div>);
  }
}

ReactiveTemplates['latestGridLayoutOne'] = latestGridLayoutOne;

ReactiveLayouts.push({
  'key': 'latestGridLayoutOne',
  'image_url': API.IMG + 'bg-img-blog.jpg',
  'type': 'all',
  'gridName': 'WinSton',
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/layout/grid/winston.js
 **/